import * as React from 'react'
import { FocusEvent, ReactElement } from 'react'
import { Field, Input, makeStyles, Textarea } from '@fluentui/react-components'

export type DiagnosticTextFieldProps = {
    label?: string
    value?: string
    onChange?: (value: string) => void
    errorMessage?: string
    readOnly?: boolean
    multiline?: boolean
    rows?: number
}

const useStyles = makeStyles({
    mono: {
        fontFamily: 'Monaco, Menlo, Consolas, monospace',
    },
})

/**
 * v9 replacement for the legacy (Fluent-v8 TextField) DiagnosticTextField: a monospace, select-on-focus field used
 * to display/copy diagnostic values. Renders a Textarea when `multiline`, otherwise an Input.
 */
export default function DiagnosticTextField(props: DiagnosticTextFieldProps): ReactElement {
    const styles = useStyles()

    const selectOnFocus = (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>): void => event.target.select()

    return (
        <Field label={props.label} validationMessage={props.errorMessage} validationState={props.errorMessage ? 'error' : 'none'}>
            {props.multiline ? (
                <Textarea
                    value={props.value ?? ''}
                    readOnly={props.readOnly}
                    resize={'vertical'}
                    rows={props.rows ?? 5}
                    textarea={{ className: styles.mono }}
                    onFocus={selectOnFocus}
                    onChange={(_event, data) => props.onChange?.(data.value)}
                />
            ) : (
                <Input
                    value={props.value ?? ''}
                    readOnly={props.readOnly}
                    input={{ className: styles.mono }}
                    onFocus={selectOnFocus}
                    onChange={(_event, data) => props.onChange?.(data.value)}
                />
            )}
        </Field>
    )
}
